import {requests} from "../../helpers/api.services";
import {BANNER_SETTINGS_URL} from "../../helpers/api.routes";

export const AdminBannerSettingsService = {
    get: () => requests.get(BANNER_SETTINGS_URL),
    create: (params: FormData) => requests.post(BANNER_SETTINGS_URL, params, true),
    delete: () => requests.delete(BANNER_SETTINGS_URL)
}